import { PlainObject } from "@core/models";
import z from "zod";

export default function createSchemaUtils<
    S extends z.ZodTypeAny,
    TExtend extends PlainObject = {}
>(schema: S, additional?: TExtend) {
    type T = z.infer<S>;
    return Object.freeze({
        ...additional,
        validate(data: unknown): data is T {
            return schema.safeParse(data).success;
        },
        tryParse(data: unknown, onError?: (error: z.ZodError) => void): T | null {
            const result = schema.safeParse(data);
            if (!result.success) {
                onError?.(result.error);
            }
            return result.success ? result.data as T : null;
        }
    });
}